import React from "react";
import PropTypes from "prop-types";
import { AlertContent, Types } from "../../../../../../CommonComponents/ContentMessages";
import ErrorPopup from "../../../../../../CommonComponents/ErrorPopup/ErrorPopup";
import { AlertWrap } from "../../style";

function DrupalPopup({
  page,
  show,
  type=[Types.PAGE_ALERTS],
  keyProperty,
  titleProperty="field_header",
  primaryProperty="field_alert_button1_text",
  secondaryProperty="field_alert_button2_text",
  descriptionProperty="field_description",
  defaultPrimaryLabel,
  defaultSecondaryLabel,
  defaultTitle,
  defaultDescription,
  primaryCta,
  secondaryCta,
  showSecondary=true,
  alertId=''
}) {
  return (
    <ErrorPopup
      show={show}
      primaryCta={primaryCta}
      primaryCtaLabel={
        primaryProperty && (
          <AlertContent
            page={page}
            type={type}
            keyProperty={keyProperty}
            property={primaryProperty}
            html={true}
            defaultMessage={defaultPrimaryLabel}
            alertId={`primaryLabel${alertId}`}
          />
        )
      }
      secondaryCtaLabel={
        showSecondary && (
          <AlertContent
            page={page}
            type={type}
            keyProperty={keyProperty}
            property={secondaryProperty}
            html={true}
            defaultMessage={defaultSecondaryLabel}
            alertId={`secondaryLabel${alertId}`}
          />
        )
      }
      secondaryCta={secondaryCta}
      title={
        titleProperty && (
          <AlertContent
            page={page}
            type={type}
            keyProperty={keyProperty}
            property={titleProperty}
            html={true}
            defaultMessage={defaultTitle}
            alertId={`title${alertId}`}
          />
        )
      }
    >
      <AlertWrap>
        {descriptionProperty && (
          <AlertContent
            page={page}
            type={type}
            keyProperty={keyProperty}
            property={descriptionProperty}
            html={true}
            defaultMessage={defaultDescription}
            alertId={`desc${alertId}`}
          />
        )}
      </AlertWrap>
    </ErrorPopup>
  );
}

DrupalPopup.propTypes = {
  page: PropTypes.string,
  show: PropTypes.bool,
  type: PropTypes.arrayOf(PropTypes.string),
  keyProperty: PropTypes.string,
  titleProperty: PropTypes.string,
  primaryProperty: PropTypes.string,
  secondaryProperty: PropTypes.string,
  descriptionProperty: PropTypes.string,
  defaultPrimaryLabel: PropTypes.string,
  defaultSecondaryLabel: PropTypes.string,
  defaultTitle: PropTypes.string,
  defaultDescription: PropTypes.string,
  primaryCta: PropTypes.func,
  secondaryCta: PropTypes.func,
  showSecondary: PropTypes.bool
}

export default DrupalPopup;
